import { URL } from "Auth/config";

export const API_ENDPOINTS = {
  PACIENTES: {
    LISTAR: `${URL}/pacientes/listar`,
    LISTAR_REDES: `${URL}/pacientes/listar-redes`,
    LISTAR_MUNICIPIOS: `${URL}/pacientes/listar-municipios`,
    LISTAR_HOSPITALES: `${URL}/pacientes/listar-hospitales`,
    REGISTRAR: `${URL}/pacientes/registrar`,
    MODIFICAR: `${URL}/pacientes/modificar`,
    ELIMINAR: `${URL}/pacientes/eliminar`,
    BUSCAR: `${URL}/pacientes/buscar`,
    OBTENER_PACIENTE: `${URL}/pacientes/obtener-paciente`
  },
  FICHA: {
    LISTAR: `${URL}/ficha/listar`,
    OBTENER_FICHA: `${URL}/ficha/obtener-ficha`,
    VER_PDF: `${URL}/ficha/ver-pdf`,
    LISTAR_REDES: `${URL}/ficha/listar-redes`,
    LISTAR_MUNICIPIOS: `${URL}/ficha/listar-municipios`,
    REGISTRAR: `${URL}/ficha/registrar`,
    MODIFICAR: `${URL}/ficha/modificar`,
    ELIMINAR: `${URL}/ficha/eliminar`,
    BUSCAR: `${URL}/ficha/buscar`,
    LISTAR_PARAMETROS: `${URL}/ficha/listar-parametros`, 
  },
  TRATAMIENTO: {
    LISTAR: `${URL}/tratamiento/listar`,
    PARAMETROS_REPORTES: `${URL}/tratamiento/parametros-reportes`,
    GENERAR_REPORTES: `${URL}/tratamiento/generar-reportes`,

    PARAMETROS_REPORTES_M: `${URL}/tratamiento-municipal/parametros-reportes`,
    GENERAR_REPORTES_M: `${URL}/tratamiento-municipal/generar-reportes`,
    
    PARAMETROS_REPORTES_D: `${URL}/reportes-tratamiento-depto/parametros-reportes`, 
    GENERAR_REPORTES_D: `${URL}/reportes-tratamiento-depto/generar-reportes`,


    VER_PDF: `${URL}/tratamiento/ver-pdf`,
    LISTAR_REDES: `${URL}/tratamiento/listar-redes`,
    LISTAR_MUNICIPIOS: `${URL}/tratamiento/listar-municipios`,
    REGISTRAR: `${URL}/tratamiento/registrar`,
    MODIFICAR: `${URL}/tratamiento/modificar`,
    ELIMINAR: `${URL}/tratamiento/eliminar`,
    BUSCAR: `${URL}/tratamiento/buscar`,
    LISTAR_PARAMETROS: `${URL}/tratamiento/listar-parametros`, 

  },
  DIAGNOSTICO: {
    LISTAR: `${URL}/diagnostico/listar`,
    VER_PDF: `${URL}/diagnostico/ver-pdf`,

    PARAMETROS_REPORTES: `${URL}/diagnostico/parametros-reportes`,
    
    LISTAR_PARAMETROS_CONCLUSION: `${URL}/diagnostico/listar-parametros-conclusion`,
    REALIZAR_CONCLUSION: `${URL}/diagnostico/realizar-conclusion-medica`,
    GENERAR_REPORTES: `${URL}/diagnostico/generar-reportes`,
    LISTAR_GRUPO_ETARIO_REPORTES: `${URL}/diagnostico/listar-grupo-etario-reportes`,


    PARAMETROS_REPORTES_M: `${URL}/diagnostico-municipal/parametros-reportes`,
    GENERAR_REPORTES_M: `${URL}/diagnostico-municipal/generar-reportes`,
    LISTAR_GRUPO_ETARIO_REPORTES_M: `${URL}/diagnostico-municipal/listar-grupo-etario-reportes`,

    
    PARAMETROS_REPORTES_D: `${URL}/reportes-diagnostico-depto/parametros-reportes`,
    GENERAR_REPORTES_D: `${URL}/reportes-diagnostico-depto/generar-reportes`,
    LISTAR_GRUPO_ETARIO_REPORTES_D: `${URL}/reportes-diagnostico-depto/listar-grupo-etario-reportes`,



    BUSCAR: `${URL}/diagnostico/buscar`,
    LISTAR_PARAMETROS: `${URL}/diagnostico/listar-parametros`,
    LISTAR_GRUPO_ETARIO: `${URL}/diagnostico/listar-grupo-etario`,
    REGISTRAR: `${URL}/diagnostico/registrar`,
    MODIFICAR: `${URL}/diagnostico/modificar`,
    ELIMINAR: `${URL}/diagnostico/eliminar`,
  },

  CONSULTAS: {
    LISTAR: `${URL}/consultas/listar`,
    LISTAR_PARAMETROS: `${URL}/consultas/listar-parametros`,
    REGISTRAR: `${URL}/consultas/registrar`,
    MODIFICAR: `${URL}/consultas/modificar`,
    ELIMINAR: `${URL}/consultas/eliminar`,
  },


  LABORATORIO: {
    VER_PDF: `${URL}/laboratorio-diagnostico/ver-pdf`,

    LISTAR: `${URL}/laboratorio-diagnostico/listar`,
    BUSCAR_PACIENTE: `${URL}/laboratorio-diagnostico/buscar-paciente`,
    LISTAR_PARAMETROS: `${URL}/laboratorio-diagnostico/listar-parametros`,
    MODIFICAR: `${URL}/laboratorio-diagnostico/modificar`,
    ELIMINAR: `${URL}/laboratorio-diagnostico/eliminar`,


    PARAMETROS_REPORTES: `${URL}/laboratorio-diagnostico/parametros-reportes`,
    GENERAR_REPORTES: `${URL}/laboratorio-diagnostico/generar-reportes`,
    LISTAR_GRUPO_ETARIO_REPORTES: `${URL}/laboratorio-diagnostico/listar-grupo-etario-reportes`,

  },

  REPORTES_TRATAMIENTO_DEPARTAMENTAL: {
    LISTAR_PARAMETROS: `${URL}/reportes-tratamiento-depto/listar-parametros`,
    LISTAR_PARAMETROS_TIPO_CONSULTA: `${URL}/reportes-tratamiento-depto/listar-parametros-tipo-consulta`,
    BUSCAR_CONSOLIDADO: `${URL}/reportes-tratamiento-depto/buscar-consolidado`,
    BUSCAR_POR_RED: `${URL}/reportes-tratamiento-depto/buscar-por-red`,
    BUSCAR_POR_MUNICIPIO: `${URL}/reportes-tratamiento-depto/buscar-por-municipio`,
    BUSCAR_POR_HOSPITAL: `${URL}/reportes-tratamiento-depto/buscar-por-hospital`,
    LISTAR_GRUPOS_ETARIOS: `${URL}/reportes-tratamiento-depto/listar-grupos-etarios`,
  },

  REPORTES_DIAGNOSTICO_DEPARTAMENTAL: {
    LISTAR_PARAMETROS: `${URL}/reportes-diagnostico-depto/listar-parametros`,
    LISTAR_PARAMETROS_TIPO_CONSULTA: `${URL}/reportes-diagnostico-depto/listar-parametros-tipo-consulta`,
    BUSCAR_CONSOLIDADO: `${URL}/reportes-diagnostico-depto/buscar-consolidado`,
    BUSCAR_POR_RED: `${URL}/reportes-diagnostico-depto/buscar-por-red`,
    BUSCAR_POR_MUNICIPIO: `${URL}/reportes-diagnostico-depto/buscar-por-municipio`,
    BUSCAR_POR_HOSPITAL: `${URL}/reportes-diagnostico-depto/buscar-por-hospital`,
    LISTAR_GRUPOS_ETARIOS: `${URL}/reportes-diagnostico-depto/listar-grupos-etarios`,
  }
};